import React from 'react';
import ImageGallery from 'react-image-gallery';
import 'react-image-gallery/styles/scss/image-gallery.scss';
import { Card, CardBody, Button } from 'reactstrap';
import logo from '../assets/images/no-image.png';

class ServiceImageGallery extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isFullscreen: false
    };
  }

  handleImageLoad = (event) => {
    // Image load handler - can be extended if needed
  };

  handleScreenChange = (isFullscreen) => {
    this.setState({ isFullscreen });
  };

  renderCustomItem = (item, index) => {
    const { isFullscreen } = this.state;
    const { userHasDeletePermission, onImageDelete, constrainHeight = false } = this.props;
    const frameHeight = isFullscreen
      ? (constrainHeight ? 'calc(100vh - 90px)' : '100vh')
      : (constrainHeight ? 'var(--service-gallery-height, 320px)' : 'auto');

    return (
      <div style={{
        maxWidth: isFullscreen ? '100%' : '100%',
        margin: '0 auto',
        position: 'relative',
        overflow: 'hidden',
        height: frameHeight,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      }}>
        {item && item.original ? (
          <>
            <img
              src={item.original}
              alt={item.name || 'service image'}
              style={{
                width: '100%',
                maxWidth: '100%',
                height: isFullscreen || constrainHeight ? '100%' : 'auto',
                maxHeight: isFullscreen ? '100vh' : '100%',
                objectFit: isFullscreen ? 'contain' : 'contain'
              }}
              onError={(e) => {
                e.target.src = logo;
              }}
            />
            {item.name !== 'logo-icon.png' && !isFullscreen ? (
              <Button
                color="danger"
                size="sm"
                disabled={!userHasDeletePermission}
                onClick={(e) => {
                  e.stopPropagation();
                  onImageDelete(item.name);
                }}
                style={{
                  position: 'absolute',
                  bottom: 20,
                  left: 10,
                  zIndex: 10
                }}
              >
                <i className="icon-trash mr-2"></i>
                Sil
              </Button>
            ) : null}

            {item.description && (
              <p style={constrainHeight ? {
                position: 'absolute', bottom: 56, left: 10, right: 10,
                maxHeight: 48, overflowY: 'auto', margin: 0, padding: '6px 8px',
                background: 'rgba(255,255,255,.9)', color: '#52627a',
                fontSize: 11, lineHeight: 1.4, whiteSpace: 'normal', borderRadius: 6
              } : { textAlign: 'center', marginTop: '10px' }}>
                {item.description}
              </p>
            )}
          </>
        ) : (
          <img
            src={require('../assets/images/logo-icon.svg')}
            alt="default"
            className="fixed-size-image"
            style={constrainHeight ? { width: '100%', height: '100%', objectFit: 'contain' } : undefined}
          />
        )}
      </div>
    );
  };

  render() {
    const { images, title = 'Servis Resimleri', loading } = this.props;

    return (
      <Card className="mb-3">
        <CardBody>
          <h6 className="text-cyan font-weight-bold text-center mb-3">
            <i className="fa fa-images mr-2"></i>
            {title}
          </h6>
          <div className="preview">
            <div className="gallery b4gallery">
              <ImageGallery
                items={images}
                renderItem={(item, index) => (
                  <div key={index} style={{ width: '100%' }}>
                    {this.renderCustomItem(item, index)}
                  </div>
                )}
                onImageLoad={this.handleImageLoad}
                lazyLoad={true}
                loading={loading || 'lazy'}
                onScreenChange={this.handleScreenChange}
                showPlayButton={true}
                showFullscreenButton={true}
                showThumbnails={true}
                thumbnailPosition="bottom"
                slideDuration={450}
              />
            </div>
          </div>
        </CardBody>
      </Card>
    );
  }
}

export default ServiceImageGallery;
